import clsx from 'clsx'
import { FC } from 'react'
import { NumberParam, useQueryParams, withDefault } from 'use-query-params'

import s from './Intent.module.css'

type Props = {
  onChange: () => void
}

export const Intent: FC<Props> = ({ onChange }) => {
  const [query, setQuery] = useQueryParams({
    intent: NumberParam,
    page: withDefault(NumberParam, 1),
  })

  const handleSubmit = (intent: number) => {
    setQuery({ intent, page: 1 })
    onChange()
  }

  return (
    <div className={s.menu}>
      <button
        className={clsx(s.menuItem, {
          [s.active]: query.intent === 1,
        })}
        onClick={() => handleSubmit(1)}
      >
        Informational
      </button>
      <button
        className={clsx(s.menuItem, {
          [s.active]: query.intent === 0,
        })}
        onClick={() => handleSubmit(0)}
      >
        Commercial
      </button>
      <button
        className={clsx(s.menuItem, {
          [s.active]: query.intent === 2,
        })}
        onClick={() => handleSubmit(2)}
      >
        Navigational
      </button>
      <button
        className={clsx(s.menuItem, {
          [s.active]: query.intent === 3,
        })}
        onClick={() => handleSubmit(3)}
      >
        Transactional
      </button>
    </div>
  )
}
